import { motion } from "framer-motion";
import { Star, Quote, ArrowUpRight } from "lucide-react";
import { TESTIMONIALS, COMPANY } from "@/lib/siteData";

export const Testimonials = () => {
  return (
    <section id="reviews" data-testid="testimonials" className="py-20 md:py-32 bg-white border-y border-black/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex items-end justify-between gap-6 mb-12 md:mb-16">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-400 mb-4">Reviews</p>
            <h2 className="font-display font-extrabold tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl">
              Trusted across<br /><span className="brand-gradient-text">the GTA.</span>
            </h2>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-5 w-5 fill-[#FF3B30] text-[#FF3B30]" />
            ))}
            <span className="ml-2 font-semibold text-neutral-700">5.0 average</span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`testimonial-${i}`}
              className="relative rounded-3xl border border-black/10 bg-[#FAFAFA] p-7 md:p-8 flex flex-col"
            >
              <Quote className="h-8 w-8 text-neutral-200 mb-5" />
              <blockquote className="text-lg leading-relaxed text-neutral-800 flex-1">"{t.quote}"</blockquote>
              <figcaption className="mt-7 flex items-center gap-4">
                <img src={t.avatar} alt={t.name} className="h-12 w-12 rounded-full object-cover ring-1 ring-black/10" />
                <div>
                  <div className="font-semibold text-neutral-900">{t.name}</div>
                  <div className="text-sm text-neutral-500">{t.location}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <div className="mt-12 md:mt-16 flex flex-col sm:flex-row items-center justify-center gap-4">
          <p className="text-neutral-600 text-center sm:text-left">Loved the work? See what more customers are saying.</p>
          <a
            data-testid="google-reviews-btn"
            href={COMPANY.googleReviewsHref}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 rounded-full border border-black/15 bg-[#FAFAFA] px-6 py-3.5 font-semibold hover:border-[#007AFF] transition-colors duration-300"
          >
            <svg viewBox="0 0 48 48" className="h-5 w-5" aria-hidden="true">
              <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z"/>
              <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z"/>
              <path fill="#FBBC05" d="M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24s.85 6.91 2.34 9.88l7.35-5.7z"/>
              <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z"/>
            </svg>
            Read our Google Reviews
            <ArrowUpRight className="h-4 w-4 text-neutral-400 group-hover:text-[#007AFF] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300" />
          </a>
        </div>
      </div>
    </section>
  );
};
